<div mat-dialog-title class="modal-header">
    <div class="d-inline-flex align-items-center">
        <mat-icon matSuffix [svgIcon]="data.icon" class="header-icon"></mat-icon>
        <h3 mat-dialog-title>{{ data.title | translate }}</h3>
    </div>
</div>
<mat-dialog-content>
    <p>{{ data.message | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="w-50">{{ 'general.actions.cancel' | translate }}</button>
    <button mat-raised-button class="w-50" [color]="data.confirmButtonColor"
            [mat-dialog-close]="true">{{ data.confirmButtonText | translate }}
    </button>
</mat-dialog-actions>
